import React from 'react';
import { Icon } from './Icon.js';
export const IconDroplet = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4.5 14C4.5 8.94766 12 2.36978 12 2.36978C12 2.36978 19.5 8.93359 19.5 14C19.5 18.6986 15.6559 21.3698 12 21.3698C8.34409 21.3698 4.5 18.6986 4.5 14Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDroplet.js.map